import { render, staticRenderFns } from "./InsuredInfoPCItem.vue?vue&type=template&id=be603774&"
import script from "./InsuredInfoPCItem.vue?vue&type=script&lang=js&"
export * from "./InsuredInfoPCItem.vue?vue&type=script&lang=js&"
import style0 from "./InsuredInfoPCItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports